import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { PagePayload } from "@core/interface/core";
import { ItAssetsConfigurationListItem, ItAssetsConfigurationItem, ItAssetsConfigurationResponse, AddItAssetsConfigurationResponse } from "@core/interface/it_assets/itAssetsConfiguration";
import { environment } from "@environment/environment";

@Injectable({
  providedIn: 'root',
})
export class ItAssetsConfigurationService {
  constructor(private http: HttpClient) {}

  getItAssetsConfigurationMasterList(key: ItAssetsConfigurationListItem, data: PagePayload) {
    switch (key) {
        case ItAssetsConfigurationListItem.Category:
            return this.getCategory(data);
        case ItAssetsConfigurationListItem.Brand:
          return this.getBrand(data);
        case ItAssetsConfigurationListItem.Condition:
          return this.getAssetsConditions(data);
        case ItAssetsConfigurationListItem.Location:
          return this.getAssetsLocation(data);
        case ItAssetsConfigurationListItem.Make:
          return this.getAssetsMake(data);
        case ItAssetsConfigurationListItem.Modal:
          return this.getAssetsModal(data);
        case ItAssetsConfigurationListItem.OS:
          return this.getAssetsOS(data);
        default:
            return this.getCategory(data);
        }
    }

    editItAssetsConfiguration(key: ItAssetsConfigurationListItem, data: ItAssetsConfigurationItem) {
    switch (key) {
        case ItAssetsConfigurationListItem.Category:
        return this.addCategory(data);
        case ItAssetsConfigurationListItem.Brand:
        return this.addBrand(data);
        case ItAssetsConfigurationListItem.Condition:
        return this.addAssetsConditions(data);
        case ItAssetsConfigurationListItem.Location:
        return this.addAssetsLocation(data);
        case ItAssetsConfigurationListItem.Make:
        return this.addAssetsMake(data);
        case ItAssetsConfigurationListItem.Modal:
        return this.addAssetsModal(data);
        case ItAssetsConfigurationListItem.OS:
        return this.addAssetsOS(data);
        default:
        return this.addCategory(data);
    }
    }

  getCategory(data?: PagePayload) {
    const filter = { ...data };
    let httpParams = new HttpParams();
    if (filter)
    Object.keys(filter).forEach((key) => {
        httpParams = httpParams.set(
        key,
        (filter[key as keyof PagePayload] as any) || ''
        );
    });
    return this.http.get<ItAssetsConfigurationResponse>(
    environment.endPoints.itAssetsCategoryList,
    {
        params: httpParams,
    }
    );
  }

  addCategory(data: ItAssetsConfigurationItem) {
    return this.http.post<AddItAssetsConfigurationResponse>(
        environment.endPoints.itAssetsCategoryAddEdit,
        data
    );
  }

  getBrand(data?: PagePayload) {
    const filter = { ...data };
    let httpParams = new HttpParams();
    if (filter)
    Object.keys(filter).forEach((key) => {
        httpParams = httpParams.set(
        key,
        (filter[key as keyof PagePayload] as any) || ''
        );
    });
    return this.http.get<ItAssetsConfigurationResponse>(
    environment.endPoints.itAssetsBrandList,
    {
        params: httpParams,
    }
    );
  }

  addBrand(data: ItAssetsConfigurationItem) {
    return this.http.post<AddItAssetsConfigurationResponse>(
        environment.endPoints.itAssetsBrandAddEdit,
        data
    );
  }

  getAssetsConditions(data?: PagePayload) {
    const filter = { ...data };
    let httpParams = new HttpParams();
    if (filter)
    Object.keys(filter).forEach((key) => {
        httpParams = httpParams.set(
        key,
        (filter[key as keyof PagePayload] as any) || ''
        );
    });
    return this.http.get<ItAssetsConfigurationResponse>(
    environment.endPoints.itAssetsConditionsList,
    {
        params: httpParams,
    }
    );
  }

  addAssetsConditions(data: ItAssetsConfigurationItem) {
    return this.http.post<AddItAssetsConfigurationResponse>(
        environment.endPoints.itAssetsConditionsAddEdit,
        data
    );
  }

  getAssetsLocation(data?: PagePayload) {
    const filter = { ...data };
    let httpParams = new HttpParams();
    if (filter)
    Object.keys(filter).forEach((key) => {
        httpParams = httpParams.set(
        key,
        (filter[key as keyof PagePayload] as any) || ''
        );
    });
    return this.http.get<ItAssetsConfigurationResponse>(
    environment.endPoints.itAssetsLocationList,
    {
        params: httpParams,
    }
    );
  }

  addAssetsLocation(data: ItAssetsConfigurationItem) {
    return this.http.post<AddItAssetsConfigurationResponse>(
        environment.endPoints.itAssetsLocationAddEdit,
        data
    );
  }

  getAssetsMake(data?: PagePayload) {
    const filter = { ...data };
    let httpParams = new HttpParams();
    if (filter)
    Object.keys(filter).forEach((key) => {
        httpParams = httpParams.set(
        key,
        (filter[key as keyof PagePayload] as any) || ''
        );
    });
    return this.http.get<ItAssetsConfigurationResponse>(
    environment.endPoints.itAssetsMakeList,
    {
        params: httpParams,
    }
    );
  }

  addAssetsMake(data: ItAssetsConfigurationItem) {
    return this.http.post<AddItAssetsConfigurationResponse>(
        environment.endPoints.itAssetsMakeAddEdit,
        data
    );
  }

  getAssetsModal(data?: PagePayload) {
    const filter = { ...data };
    let httpParams = new HttpParams();
    if (filter)
    Object.keys(filter).forEach((key) => {
        httpParams = httpParams.set(
        key,
        (filter[key as keyof PagePayload] as any) || ''
        );
    });
    return this.http.get<ItAssetsConfigurationResponse>(
    environment.endPoints.itAssetsModalList,
    {
        params: httpParams,
    }
    );
  }

  addAssetsModal(data: ItAssetsConfigurationItem) {
    return this.http.post<AddItAssetsConfigurationResponse>(
        environment.endPoints.itAssetsModalAddEdit,
        data
    );
  }

  getAssetsOS(data?: PagePayload) {
    const filter = { ...data };
    let httpParams = new HttpParams();
    if (filter)
    Object.keys(filter).forEach((key) => {
        httpParams = httpParams.set(
        key,
        (filter[key as keyof PagePayload] as any) || ''
        );
    });
    return this.http.get<ItAssetsConfigurationResponse>(
    environment.endPoints.itAssetsOSList,
    {
        params: httpParams,
    }
    );
  }

  addAssetsOS(data: ItAssetsConfigurationItem) {
    return this.http.post<AddItAssetsConfigurationResponse>(
        environment.endPoints.itAssetsOSAddEdit,
        data
    );
  }
      
}